


























































import { State } from "xstate";
import { defineComponent, ref } from "@vue/composition-api";

import Tooltip from "@/components/Tooltip.vue";
import { Context } from "@/tools/msa/utils/machine";
import { sendExportToTelemetry } from "@/tools/msa/utils/export";

interface Props {
  state: State<Context>;
}

export default defineComponent<Props>({
  name: "ExportButton",
  components: { Tooltip },
  props: {
    state: { type: Object }
  },
  setup(props, context) {
    const errors = ref<any[]>([]);

    const isLoading = ref<boolean>(false);

    const pushError = (type: string) => {
      const reference = { type };
      errors.value.push(reference);
      setTimeout(
        () =>
          errors.value.splice(
            errors.value.findIndex(error => error === reference),
            1
          ),
        2500
      );
    };

    const trigger = async () => {
      isLoading.value = true;

      await sendExportToTelemetry(
        props.state.context.session!,
        props.state.context.sessionId!
      )
        .then(() => context.emit("export"))
        .catch(error => {
          if (!error.config) return pushError("NON_AXIOS_ERROR");
          if (!error.response) return pushError("SERVER_UNREACHABLE");
          if (Math.floor(error.response.status / 100) === 5)
            return pushError("INTERNAL_SERVER_ERROR");
          pushError("UNKNOWN_ERROR");
        })
        .finally(() => (isLoading.value = false));
    };

    return { isLoading, errors, trigger };
  }
});
